// Copyright (c) 2020 WiseTime. All rights reserved.

import React from "react"
import styled, { css, SimpleInterpolation } from "styled-components/macro"
import ActionTimeRow from "./ActionTimeRow"
import { TimeRow, TrashStatus } from "../../../generated/wisetime/user/timeline/v4/timeline_pb"
import { getDescription } from "../timeRows"

const ActionRows = styled.ul`
  list-style: none;
  width: 100%;
  margin: 0;
  border-bottom: 1px solid ${({ theme }): string => theme.colors.mercury};
  min-height: 34px;
  overflow-y: auto;
  ${({ theme }): SimpleInterpolation => {
    return css`
      max-height: calc(100vh - 295px);
      max-height: calc(100dvh - 295px);
      border-top: 1px solid ${theme.colors.mercury};
    `
  }}
`

type Props = {
  timeRows?: TimeRow.AsObject[],
}

const ActionTimeRowList = ({ timeRows = []}: Props): React.ReactElement<Props> | null => {

  if (timeRows.length === 0) {
    return null
  }

  return (
    <ActionRows>
      {timeRows.map((timeRow: TimeRow.AsObject) => (
        <ActionTimeRow
          key={timeRow.id}
          timeRowId={timeRow.id}
          activity={timeRow.activity}
          description={getDescription(timeRow.description)}
          iconUrl={timeRow.iconUrl}
          duration={timeRow.duration?.seconds}
          isTrashed={timeRow.trashStatus === TrashStatus.TRASHED}
        />
      ))}
    </ActionRows>
  )
}

export default ActionTimeRowList
